module.exports = __webpack_public_path__ + "img/search-icon-with-bg-red.3289604e.svg";